import AiResistantHomeworkIdeaView from "@features/tools/view/ai-resistant-homework-ideas";

const AiResistantHomeworkIdeas = () => {
  return <AiResistantHomeworkIdeaView />;
};

export default AiResistantHomeworkIdeas;
